import React from 'react';
import { useFieldArray } from 'react-hook-form';
import InputText from '../InputText';
import CheckboxSwitch from '../CheckboxSwitch';
import Select from '../Select';

const CURRENCY = [{
    value: 'RUB',
    label: 'RUB',
}, {
    value: 'KZT',
    label: 'KZT',
}, {
    label: 'UZS',
    value: 'UZS',
}, {
    label: 'TRY',
    value: 'TRY',
}, {
    label: 'GEL',
    value: 'GEL'
}, {
    label: 'USD',
    value: 'USD'
}, {
    label: 'EUR',
    value: 'EUR'
}, {
    label: 'INR',
    value: 'INR'
}]

const Freespin = ({
    control,
    register
}) => {
    const { fields } = useFieldArray({
        control,
        name: 'freespins'
    })

    return (
        <div>
            <div>
                <h3 style={{color: '#FFF'}}>Настройка фриспинов</h3>
            </div>
            {
                fields.map((item, index) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: 150 }}>
                            <Select
                                register={register}
                                name={`freespins[${index}].currency`}
                                label="Валюта"
                                items={CURRENCY}
                                defaultLabel="Выбрать валюту"
                                isDisabled
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', columnGap: 10 }}>
                            <div style={{ width: 100 }}>
                                <InputText
                                    name={`freespins[${index}].total_bet`}
                                    type="number"
                                    register={register}
                                    control={control}
                                    label="Total Bet"
                                />
                            </div>
                            <div style={{ width: 100 }}>
                                <InputText
                                    name={`freespins[${index}].bet_id`}
                                    type="number"
                                    register={register}
                                    control={control}
                                    label="Bet Id"
                                />
                            </div>
                            <div style={{ width: 100 }}>
                                <InputText
                                    name={`freespins[${index}].denomination`}
                                    type="number"
                                    register={register}
                                    control={control}
                                    label="Denomination"
                                />
                            </div>
                            <div style={{ width: 150 }}>
                                <CheckboxSwitch
                                    register={register}
                                    control={control}
                                    name={`freespins[${index}].is_disabled`}
                                    label="Признак отключения"
                                />
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default Freespin;